import StarIcon from '@mui/icons-material/Star';
import { Box } from '@mui/material';
import { REVIEW_STARS_COUNT } from './ReviewRating.helper';
import { reviewStarIconStyles, reviewStarsBaseStyles, reviewStarsFillStyles, reviewStarsWrapperStyles } from './ReviewRating.styles';
export default function ReviewStars({
  rating
}: Readonly<{
  rating: number;
}>) {
  const ratingPercent = rating / REVIEW_STARS_COUNT * 100;
  const renderStars = () => Array.from({
    length: REVIEW_STARS_COUNT
  }, (_, index) => <StarIcon key={index} sx={reviewStarIconStyles} />);
  return <Box sx={reviewStarsWrapperStyles} role="img" aria-label={`${rating.toFixed(1)} out of ${REVIEW_STARS_COUNT} stars`} data-testid="location_card_review_stars" data-sentry-element="Box" data-sentry-component="ReviewStars" data-sentry-source-file="ReviewStars.tsx">
			<Box sx={reviewStarsBaseStyles} data-sentry-element="Box" data-sentry-source-file="ReviewStars.tsx">{renderStars()}</Box>
			<Box sx={reviewStarsFillStyles(ratingPercent)} data-testid="location_card_review_stars_fill" data-sentry-element="Box" data-sentry-source-file="ReviewStars.tsx">
				{renderStars()}
			</Box>
		</Box>;
}